module.exports = __webpack_public_path__ + "img/img_icon.10e96790.png";